__turbopack_context__.v({
  "list": "LatestNews-module-scss-module__6epmaW__list",
  "listItem": "LatestNews-module-scss-module__6epmaW__listItem",
  "listLink": "LatestNews-module-scss-module__6epmaW__listLink",
  "listTime": "LatestNews-module-scss-module__6epmaW__listTime",
  "listWrap": "LatestNews-module-scss-module__6epmaW__listWrap",
  "viewMore": "LatestNews-module-scss-module__6epmaW__viewMore",
});
